import {b as b$1}from'./chunk-BQVQIIVZ.js';import {a}from'./chunk-FXGGYGMU.js';import {b}from'./chunk-BVQ42ESU.js';import {GooglePay,AdyenCheckout,Dropin}from'@adyen/adyen-web/auto';import'@adyen/adyen-web/styles/adyen.css';import {useState,useRef,useMemo,useCallback,useEffect,useImperativeHandle}from'react';import Pe from'styled-components';import {defineMessages,useLocales}from'@sevenrooms/locales';import {useController}from'@sevenrooms/form';import {useTheme}from'@sevenrooms/ui-kit';import {jsx}from'react/jsx-runtime';import {RTKUtils,srGet,throwFetchError,srPostJson}from'@sevenrooms/api';import le from'camelcase-keys';import {removeBeforeUnloadListener}from'@sevenrooms/ui-kit/hooks';var M=defineMessages({paymentDetailsOnSubmit:{id:"adyen.checkout.paymentDetailsOnSubmit",defaultMessage:"Payment details will be collected after clicking Submit."},problemWithCard:{id:"adyen.checkout.problemWithCard",defaultMessage:"Checkout failed. Please try another card."},cardSaveDisclaimer:{id:"adyen.checkout.cardSaveDisclaimer",defaultMessage:"By providing your card information, you allow {venueName} to charge your card for future payments in accordance with their terms."}});var q={ca:"ca-ES",da:"da-DK",de:"de-DE",en:"en-US",es:"es-ES",et:"et-EE",fr:"fr-FR",hu:"hu-HU",is:"is-IS",it:"it-IT",ja:"ja-JP",nl:"nl-NL",pt:"pt-PT",sv:"sv-SE",zh_CN:"zh-CN",nb:"en-US",th:"en-US",tr:"en-US",zh_HK:"en-US",lang:"en-US"},G=e=>q[e]||q.en;var[me,U]=b();function Le({paymentSettings:e,children:o,countryCode:n,currencyCode:g}){let[b,F]=useState(undefined),[p,c]=useState(),[y,D]=useState(),[C,h]=useState(false),[u,v]=useState(""),L=useRef(null),[f,l]=useState(),[I,i]=useState(),[r,P]=useState(),[R,w]=useState(),[x,k]=useState(),[m,S]=useState(),N=useMemo(()=>e.isProd?true:typeof window.Cypress>"u",[e.isProd]),s=G(e.selectedLanguage);return jsx(me,{value:{paymentType:b,locale:s,setPaymentType:F,paymentData:p,setPaymentData:c,paymentAdditionalData:y,setPaymentAdditionalData:D,isValid:C,setIsValid:h,actualToken:u,setActualToken:v,adyenRef:L,adyenSDK:f,setAdyenSDK:l,dropIn:I,setDropIn:i,paymentResult:r,setPaymentResult:P,actions:R,setActions:w,countryCode:n,currencyCode:g,paymentError:x,setPaymentError:k,pendingReservationContext:m,setPendingReservationContext:S,redirectFromTopWhenInIframe:N,paymentAccountId:e?.paymentAccountId},children:o})}async function J({venueId:e}){let o=`/api-yoa/adyen/${e}/get_initial_data`,{data:n}=await srGet(o).then(throwFetchError);return le(n,{deep:true})}async function X({venueId:e,paymentData:o,pendingReservationContext:n}){let g=`/api-yoa/adyen/${e}/post_payment_details`,{data:b}=await srPostJson(g,{payment_details:o,actual_id:n.actualId,booking_from:n.bookingFrom,history_id:n.historyId}).then(throwFetchError);return b}var{useGetInitialDataQuery:Z,usePostPaymentDetailsMutation:ee}=a.enhanceEndpoints({addTagTypes:["PaymentsAdyenAPI"]}).injectEndpoints({endpoints:e=>({getInitialData:e.query({providesTags:["PaymentsAdyenAPI"],queryFn:RTKUtils.rtkQuery(J)}),postPaymentDetails:e.mutation({queryFn:RTKUtils.rtkQuery(X)})})});var Ce="%{linkText}";function ct(){let{venueId:e,venueName:o,amount:n,isPaymentSectionValidField:g,setIsSubmitting:b}=b$1(),{formatMessage:F}=useLocales(),p=useRef(n),{field:{ref:c,onChange:y}}=useController(g),D=useCallback(_=>y(_),[y]),[C,h]=useState(false),[u,v]=useState(n),[L,f]=useState(false),{data:l}=Z({venueId:e}),I=useTheme(),{adyenRef:i,setAdyenSDK:r,setIsValid:P,setPaymentData:R,paymentType:w,setPaymentType:x,locale:k,dropIn:m,setDropIn:S,setActions:N,countryCode:s,currencyCode:a,setPaymentError:A,setPaymentAdditionalData:H,redirectFromTopWhenInIframe:V,paymentAccountId:ne}=U(),[oe,ae]=useState(false);return useEffect(()=>{let _;try{_=window.self!==window.top&&window.parent.location.hostname!==window.location.hostname;}catch{_=true;}ae(_);},[]),useImperativeHandle(c,()=>({blur:()=>{},focus:()=>{i?.current?.scrollIntoView({behavior:"smooth",block:"center"});},reset:()=>{}}),[i]),useEffect(()=>{p.current=n;},[n]),useEffect(()=>{if(!l)return;if(m){let t=m?.props?.paymentMethodsConfiguration?.googlepay?.amount?.value,$=n*100;if(w==="googlepay"&&(t!==$||n!==u))m?.unmount(),v(n),h(false);else return}let _={base:{font:I?.textStyles?.body1,fontWeight:"normal"}},K=l.paymentMethods.message;oe&&(K={...K,paymentMethods:K.paymentMethods?.filter(t=>t.type!=="ideal")});let re={paymentMethodsResponse:K,clientKey:l.clientKey,locale:k,environment:l.environment,showPayButton:false,countryCode:s.toUpperCase(),redirectFromTopWhenInIframe:V,onChange(t){P(t?.isValid),D(t?.isValid);},onSubmit(t,$,E){N(E),R(t);},onError(t){if(t?.message?.startsWith("AbortError")){b(false);return}A(t);},onActionHandled(t){t.componentType==="3DS2Challenge"&&i?.current?.scrollIntoView({behavior:"smooth",block:"center"});},onAdditionalDetails(t){H(t.data);}},ie={paymentMethodsConfiguration:{googlepay:{amount:{value:n*100,currency:a},configuration:{merchantName:o,gatewayMerchantId:ne||""}},applepay:{amount:{value:n*100,currency:a}},card:{styles:_,hasHolderName:true,positionHolderNameOnTop:true,holderNameRequired:true,...n===0&&{disclaimerMessage:{message:F(M.cardSaveDisclaimer,{venueName:o})+Ce,linkText:"",link:"https://sevenrooms.com/terms-of-service/"}}},bcmc:{styles:_}},onSelect:t=>{let $=t.props.type,E;t instanceof GooglePay?(E=!!t?.isReadyToPay,f(p?.current?p.current!==u:false)):(E=t.isValid,f(false)),x($),P(E),D(E);},showPayButton:false};AdyenCheckout(re).then(t=>{if(!i.current)return;m&&m?.unmount();let $=new Dropin(t,ie).mount(i.current);S($),C?t.update({locale:k}):h(true),r(t);});},[l,i,k,r,P,R,w,x,n,p,L]),jsx(ve,{ref:i,"data-test":"adyen-checkout"})}var ve=Pe.div`
  .adyen-checkout__dropin,
  .adyen-checkout__field--expiryDate,
  .adyen-checkout__field__cvc,
  .adyen-checkout__card__holderName,
  .adyen-checkout__dropdown__element {
    font: ${e=>e.theme.textStyles.body1};
    color: ${e=>e.theme.colors.primaryFont};
  }

  .adyen-checkout__input,
  .adyen-checkout__card__cardNumber__input,
  .adyen-checkout__card__cardNumber__input:hover,
  .adyen-checkout__card__cardNumber__input:focus,
  .adyen-checkout__card__cardNumber__input:active,
  .adyen-checkout__card__cardNumber__input:active:hover {
    border: none !important;
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input {
    color: ${e=>e.theme.colors.primaryFont};
    font: ${e=>e.theme.textStyles.body1};
    caret-color: ${e=>e.theme.colors.primaryFont};
    padding: ${e=>e.theme.spacing.sm} ${e=>e.theme.spacing.m};
    height: ${e=>e.theme.fieldHeight.m};
  }

  .adyen-checkout__dropdown__button--active,
  .adyen-checkout__dropdown__button--active:hover,
  .adyen-checkout__dropdown__button:active,
  .adyen-checkout__dropdown__button:focus,
  .adyen-checkout__dropdown__button:hover,
  .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__image__wrapper {
    border: 1px solid ${e=>e.theme.colors.borderFocus} !important;
    box-shadow: none;
  }

  .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__image__wrapper {
    transform: scale(1.2);
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input {
    border-radius: ${e=>e.theme.borderRadius.s};
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input,
  .adyen-checkout__dropdown__button--valid,
  .adyen-checkout__input--valid {
    border-color: ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__input--error {
    border-color: ${e=>e.theme.colors.error};
  }

  .adyen-checkout__payment-methods-list {
    gap: 0;
  }

  .adyen-checkout__payment-method__image__wrapper {
    border: 1px solid ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__payment-method {
    padding-left: ${e=>e.theme.spacing.s};
    padding-right: ${e=>e.theme.spacing.s};
  }

  .adyen-checkout__payment-method {
    border: none;
  }

  .adyen-checkout__payment-method--selected,
  .adyen-checkout__payment-method__details__content {
    margin: ${e=>e.theme.spacing.none};
    background: ${e=>e.theme.colors.infoBackground};
  }

  .adyen-checkout__payment-method:first-child {
    border-radius: ${e=>e.theme.borderRadius.none};
  }

  .adyen-checkout__payment-method:not(:first-child) {
    border-top: ${e=>`${e.theme.borderWidth.s} solid ${e.theme.colors.borders}`};
    border-radius: ${e=>e.theme.borderRadius.none};
  }

  .adyen-checkout__label__text,
  .adyen-checkout__fieldset__title,
  .adyen-checkout__label--focused,
  .adyen-checkout-form-instruction {
    font: ${e=>e.theme.textStyles.body1};
    color: ${e=>e.theme.colors.primaryFont};
    margin-bottom: ${e=>e.theme.spacing.s};
    text-transform: capitalize;
    padding: initial;
  }

  .adyen-checkout__fieldset__title {
    font: ${e=>e.theme.textStyles.h3};
    margin-bottom: ${e=>e.theme.spacing.m};
    letter-spacing: initial;
  }

  .adyen-checkout__payment-method__name {
    font: ${e=>e.theme.textStyles.body1};
  }

  .adyen-checkout__payment-method__name--selected {
    font: ${e=>e.theme.textStyles.body1bold};
  }

  .adyen-checkout-contextual-text--error {
    font: ${e=>e.theme.textStyles.error};
    margin-top: ${e=>e.theme.spacing.s};
  }

  .adyen-checkout-form-instruction {
    color: ${e=>e.theme.colors.secondaryFont};
    margin-bottom: ${e=>e.theme.spacing.m};
  }

  // requirement from the design team to hide form instructions and validation icons
  .adyen-checkout-form-instruction,
  .adyen-checkout-input__inline-validation {
    display: none;
  }

  .adyen-checkout__dropdown__button--valid {
    border-bottom-color: ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__input::placeholder {
    font: ${e=>e.theme.textStyles.body1};
  }

  .adyen-checkout__card__cardNumber__input {
    border: none;
  }

  fieldset {
    padding: ${e=>e.theme.spacing.none};
  }

  .adyen-checkout__dropdown__element,
  .adyen-checkout__filter-input {
    text-transform: capitalize;
  }
`;function gt({venueId:e}){let{actions:o,paymentData:n,setPaymentData:g,setPendingReservationContext:b,adyenSDK:F,adyenRef:p,dropIn:c,paymentError:y,paymentAdditionalData:D,pendingReservationContext:C,paymentType:h}=U(),{formatMessage:u}=useLocales(),[v,L]=useState(),[f,l]=useState(),[I,i]=useState(),[r,P]=useState(),[R,w]=useState(false),[x,k]=useState(false),[m]=ee(),S=useCallback(s=>{o?.resolve({resultCode:"Authorised"}),I?.(s);},[I,o]),N=useCallback(async s=>{if(c)try{let a=await m({venueId:e,paymentData:s,pendingReservationContext:C}).unwrap();a.resultCode==="Authorised"?(c.setStatus("success",{message:"Payment successful!"}),S({token:a?.token})):(o?.reject({}),r?.({errors:[u(M.problemWithCard)]}));}catch{o?.reject({}),r?.({errors:[u(M.problemWithCard)]});}},[o,m,c,u,S,r,C,e]);if(D&&c&&!x&&(k(true),N(D)),y&&r&&r({errors:[y]}),n&&f){let s={...v,chargeData:{...v?.chargeData,cardData:n?.data}};f&&!R&&(w(true),f?.(s).then(a=>{if(a?.adyenActionFor3DSecure){let A=a?.extraData?.metadata;b({actualId:A.actualId,historyId:A.historyId,bookingFrom:A.bookingFrom}),removeBeforeUnloadListener(),h==="paypal"?F?.createFromAction(a?.adyenActionFor3DSecure).mount(p.current):o?.resolve(a?.extraData?.rawResponse);return}a?.status==="success"?S(a):(o?.reject({}),r?.({errors:[u(M.problemWithCard)]}));}).catch(a=>{r?.({errors:[y||""]});}));}return async({data:s,submitBookReservation:a,onSuccessfulBooking:A,onFailure:H})=>{try{L(s),l(()=>a),i(()=>A),P(()=>H),h==="paypal"?(c?.setStatus("paymentPending"),g({data:{paymentMethod:{type:h}}})):c?.submit();}catch(V){H&&(window.history.go(-1),H(V));}}}export{Le as a,ct as b,gt as c};